import { render, staticRenderFns } from "./CustomerAnalytics.vue?vue&type=template&id=35862c04&scoped=true&"
import script from "./CustomerAnalytics.vue?vue&type=script&lang=js&"
export * from "./CustomerAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAnalytics.vue?vue&type=style&index=0&id=35862c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35862c04",
  null
  
)

export default component.exports